const DOMPurify = require('dompurify');
export default class VimeoService {
  constructor() {
    _.extend(this, Backbone.Events);
  }

  loadVideo(options, videoId) {
    // percentage values are not allowed/ do not work
    const width = /%$/.test(options.width) ? undefined : options.width;
    const height = /%$/.test(options.height) ? undefined : options.height;

    return new window.Vimeo.Player(options.container, {
      height: height || '360',
      width: width || '640',
      id: videoId
    });
  }

  initVideo(videoId, options) {
    let matches = videoId.match(/(?:http|https)?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|)(\d+)(?:|\/\?)/);
    if(matches) {
      videoId = matches[1];
    }

    if(window.Vimeo && window.Vimeo.Player) {
      this.loadVideo(options, videoId);

    } else {
      let script = document.head.querySelector('script[src="https://player.vimeo.com/api/player.js"]');
      if(script === null) {
        script = document.createElement('script');
        script.onload = () => {
          this.loadVideo(options, videoId);
        }
        script.src = 'https://player.vimeo.com/api/player.js';
        DOMPurify.sanitize(script.src);
        document.head.appendChild(script);
      }
    }
  }

  dispose() { }
}
